import { render, staticRenderFns } from "./Unverified.vue?vue&type=template&id=8a67077c&"
import script from "./Unverified.vue?vue&type=script&lang=js&"
export * from "./Unverified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports